import styled from "@emotion/styled";
import { Tabs as MuiTabs } from "@mui/material";


const Tabs = styled((props) => (
    <MuiTabs disableRipple {...props} />
))(() => ({
    '& .MuiButtonBase-root': {
        // background: '#3571ff',
        borderRadius: '.5rem',
        marginRight: '.5rem',
        color: '#828282',
        minHeight: '36px',
        padding: '.5rem .75rem',
        marginBottom: '.5rem',
        border: '2px solid #0000001A'
    },
    '& .MuiTabs-indicator': {
        display: 'none'
    },
    '& .MuiTabs-flexContainer': {
        flexWrap: 'wrap'
    },
    '& .Mui-selected': {
        color: '#fff !important',
        background: '#3571ff'
    }

}),
);

export default Tabs;